module.exports = __webpack_public_path__ + "static/img/5740_phase_function_Paper_Points.898eadd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5740_phase_function_Paper_Points.png
// module id = w3Fu
// module chunks = 0